"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Spinner_1 = require("office-ui-fabric-react/lib/Spinner");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var Image_1 = require("office-ui-fabric-react/lib/Image");
var ListingNavHelper_1 = require("./ListingNavHelper");
var onClickBackItem = function (e, item) {
    var host = item.host;
    var navStack = ListingNavHelper_1.getNavStack(host);
    if (navStack && navStack.length > 0) {
        host.load(navStack.pop());
    }
};
var createBackItem = function (host) {
    var navStack = ListingNavHelper_1.getNavStack(host);
    if (navStack && navStack.length > 0) {
        var e = navStack[navStack.length - 1];
        return {
            key: "back",
            iconProps: {
                iconName: "Back"
            },
            host: host,
            path: e.path,
            title: e.title ? "Back to " + e.title : "Back",
            onClick: onClickBackItem
        };
    }
};
exports.createBackItem = createBackItem;
var renderIcon = function (listingSupplier) {
    var icon;
    if (listingSupplier.sync.syncing) {
        icon = React.createElement(Spinner_1.Spinner, { size: Spinner_1.SpinnerSize.small });
    }
    else if (listingSupplier.sync.error) {
        icon = React.createElement(Icon_1.Icon, { iconName: "Error" });
    }
    else if (listingSupplier.value.small_icon && listingSupplier.value.small_icon.url) {
        icon = React.createElement(Image_1.Image, { src: listingSupplier.value.small_icon.url, width: 16, height: 16 });
    }
    else {
        icon = React.createElement(Icon_1.Icon, { iconName: "Puzzle" });
    }
    return icon;
};
exports.renderIcon = renderIcon;
